var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{attrs:{"day":_vm.day,"color":"gray"}},[_c('div',{staticClass:"body"},[_c('div',{staticClass:"body__sold-out"},[_vm._v("Sold out")]),_c('div',{staticClass:"fill fill--gray"})])])}
var staticRenderFns = []

export { render, staticRenderFns }